(() => {
  const root = (window.KABO && window.KABO.root) || '/';
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency', currency: (window.KABO && window.KABO.currency) || 'EUR'
      }).format((Number(cents) || 0) / 100);
    } catch (_) { return `${((Number(cents) || 0) / 100).toFixed(2)} €`; }
  };
  const freeShippingThreshold = Math.max(0, Number((window.KABO && window.KABO.freeShippingThreshold) || 5500));

  document.querySelectorAll('#MainContent a[href="mailto:akadir.kobal@gmail.com"]').forEach((link) => {
    link.setAttribute('href', 'mailto:kontakt@simplykabo.de');
  });

  document.querySelectorAll('form[action="/search"], form[action$="/search"]').forEach((form) => {
    if (form.querySelector('input[name="type"]')) return;
    const productType = document.createElement('input');
    productType.type = 'hidden';
    productType.name = 'type';
    productType.value = 'product';
    form.appendChild(productType);
  });

  const searchPage = document.querySelector('.main-search');
  if (searchPage) {
    const resultsHeading = searchPage.querySelector('.section-heading h2');
    const resultsGrid = searchPage.querySelector('.product-grid');
    if (resultsHeading && resultsGrid) {
      const visibleResults = resultsGrid.querySelectorAll('.product-card:not([hidden])').length;
      const resultLabel = visibleResults === 1 ? 'Ergebnis' : 'Ergebnisse';
      resultsHeading.textContent = resultsHeading.textContent.replace(/^\d+\s+Ergebnis(?:se)?\s+für\s+/u, `${visibleResults} ${resultLabel} für `);
    }
  }

  function updateShippingNote(note, amount) {
    if (!note) return;
    const hasFreeShipping = Number(amount) >= freeShippingThreshold;
    note.querySelectorAll('[data-shipping-paid]').forEach((copy) => { copy.hidden = hasFreeShipping; });
    note.querySelectorAll('[data-shipping-free]').forEach((copy) => { copy.hidden = !hasFreeShipping; });
  }

  function updateShippingProgress(progress, amount) {
    if (!progress || freeShippingThreshold <= 0) return;
    const total = Math.max(0, Number(amount) || 0);
    const remaining = Math.max(0, freeShippingThreshold - total);
    const percentage = Math.min(100, Math.round(total / freeShippingThreshold * 100));
    const copy = progress.querySelector('[data-free-shipping-copy]');
    const track = progress.querySelector('[data-free-shipping-track]');
    const fill = progress.querySelector('[data-free-shipping-fill]');
    if (copy) copy.textContent = remaining > 0
      ? `Noch ${money(remaining)} bis zum kostenlosen Versand`
      : 'Kostenloser Versand ist für dich freigeschaltet';
    if (track) track.setAttribute('aria-valuenow', String(percentage));
    if (fill) fill.style.width = `${percentage}%`;
  }

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartContent = document.querySelector('[data-cart-drawer-content]');
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchInput = searchOverlay && searchOverlay.querySelector('[data-search-input]');
  let searchStartScrollY = 0;
  let searchScrollBlurred = false;

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = count || 0; });
  }

  function openDrawer() {
    if (!cartDrawer || !window.KABO.cartDrawer) {
      window.location.href = window.KABO.cartUrl || `${root}cart`;
      return;
    }
    closeSearch();
    cartDrawer.hidden = false;
    document.body.classList.add('drawer-open');
    refreshCart();
  }

  function closeDrawer() {
    if (!cartDrawer) return;
    cartDrawer.hidden = true;
    document.body.classList.remove('drawer-open');
  }

  function closeMobileMenu() {
    const nav = document.querySelector('[data-mobile-nav]');
    if (nav) nav.hidden = true;
    document.body.classList.remove('menu-open');
    document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
  }

  function openSearch() {
    if (!searchOverlay) {
      window.location.href = `${root}search`;
      return;
    }
    closeDrawer();
    closeMobileMenu();
    searchStartScrollY = window.scrollY;
    searchScrollBlurred = false;
    searchOverlay.hidden = false;
    document.body.classList.add('search-open');
    document.querySelectorAll('[data-search-open]').forEach((button) => button.setAttribute('aria-expanded', 'true'));
    window.setTimeout(() => {
      if (searchInput) searchInput.focus({ preventScroll: true });
    }, 40);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.hidden = true;
    document.body.classList.remove('search-open');
    document.querySelectorAll('[data-search-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    searchScrollBlurred = false;
  }

  async function getCart() {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  }

  function splitProductTitle(title) {
    const parts = String(title || '').split(' – ');
    return {
      name: parts.shift() || '',
      descriptor: parts.join(' – ')
    };
  }

  const localizedVariantLabels = new Map([
    ['color', 'Farbe'],
    ['colour', 'Farbe'],
    ['electrical outlet', 'Anschluss'],
    ['power', 'Anschluss'],
    ['black', 'Schwarz'],
    ['black 2-pack', 'Schwarz · 2er-Pack'],
    ['bright blue', 'Hellblau'],
    ['light blue', 'Hellblau'],
    ['dark blue', 'Dunkelblau'],
    ['navy', 'Dunkelblau'],
    ['gray', 'Grau'],
    ['grey', 'Grau'],
    ['light grey', 'Hellgrau'],
    ['korea lan', 'Blau'],
    ['coffee', 'Braun'],
    ['green', 'Grün'],
    ['purple', 'Lila'],
    ['yellow', 'Gelb'],
    ['white', 'Weiß'],
    ['white a', 'Weiß (USB)'],
    ['wood color', 'Holzoptik'],
    ['standard 2nd', 'Standard · 2. Generation'],
    ['schwarz', 'Schwarz']
  ]);

  function localizeVariantLabel(value) {
    const label = String(value || '').trim();
    return localizedVariantLabels.get(label.toLocaleLowerCase()) || label;
  }

  function localizeVariantTitle(value) {
    return String(value || '')
      .split(/\s*\/\s*/)
      .map(localizeVariantLabel)
      .join(' / ');
  }

  function renderCart(cart) {
    setCartCount(cart.item_count);
    if (!cartContent) return;
    if (!cart.item_count) {
      cartContent.innerHTML = `<div class="empty-state"><h2>Noch nichts drin.</h2><p>Entdecke unsere aktuellen KABO-Produkte.</p><a class="button button--primary" href="${root}collections/all">Produkte entdecken</a></div>`;
      return;
    }
    const items = cart.items.map((item) => {
      const title = splitProductTitle(item.product_title);
      const imageUrl = item.image || (item.featured_image && item.featured_image.url) || '';
      const img = imageUrl ? `<img src="${escapeAttr(imageUrl)}" alt="${escapeAttr(item.product_title)}">` : '';
      const descriptor = title.descriptor ? `<small class="drawer-item__descriptor">${escapeHtml(title.descriptor)}</small>` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<small class="drawer-item__variant">${escapeHtml(localizeVariantTitle(item.variant_title))}</small>` : '';
      return `<div class="drawer-item">
        <a href="${item.url}" class="drawer-item__image">${img}</a>
        <div class="drawer-item__meta">
          <a href="${item.url}" class="drawer-item__title"><strong>${escapeHtml(title.name)}</strong>${descriptor}</a>
          ${variant}
          <small class="drawer-item__unit-price">${money(item.final_price)}</small>
          <div class="drawer-item__qty"><button type="button" data-cart-change="${escapeAttr(item.key)}" data-quantity="${Math.max(0,item.quantity-1)}">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${escapeAttr(item.key)}" data-quantity="${item.quantity+1}">+</button></div>
        </div>
        <strong class="drawer-item__total">${money(item.final_line_price)}</strong>
      </div>`;
    }).join('');
    const shippingCopy = cart.total_price >= freeShippingThreshold
      ? 'Kostenloser Versand innerhalb Deutschlands.'
      : '4,99 € Versand innerhalb Deutschlands · ab 55 € versandfrei.';
    const remaining = Math.max(0, freeShippingThreshold - cart.total_price);
    const progress = freeShippingThreshold > 0 ? Math.min(100, Math.round(cart.total_price / freeShippingThreshold * 100)) : 100;
    const progressCopy = remaining > 0
      ? `Noch ${money(remaining)} bis zum kostenlosen Versand`
      : 'Kostenloser Versand ist für dich freigeschaltet';
    cartContent.innerHTML = `${items}<div class="drawer-summary"><div class="drawer-summary__row"><span>Zwischensumme</span><span>${money(cart.total_price)}</span></div><small>${shippingCopy}</small><div class="shipping-progress"><p class="shipping-progress__copy">${progressCopy}</p><span class="shipping-progress__track" role="progressbar" aria-label="Fortschritt zum kostenlosen Versand" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${progress}"><span class="shipping-progress__fill" style="width:${progress}%"></span></span></div><a class="button button--primary button--full" href="${root}checkout">Zur Kasse</a><a class="drawer-summary__cart-link" href="${window.KABO.cartUrl || `${root}cart`}">Warenkorb ansehen</a><p class="drawer-summary__trust">Sicher bezahlen · 14 Tage Widerrufsrecht</p></div>`;
  }

  async function refreshCart() {
    try { renderCart(await getCart()); } catch (error) { console.error(error); }
  }

  async function changeCart(key, quantity) {
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!response.ok) throw new Error('Cart update failed');
      renderCart(await response.json());
    } catch (error) { console.error(error); }
  }

  function updateCartPagePreview() {
    const form = document.querySelector('[data-cart-page-form]');
    if (!form) return;
    let subtotal = 0;
    form.querySelectorAll('[data-cart-page-line]').forEach((line) => {
      const input = line.querySelector('[data-cart-page-qty]');
      const unitPrice = Math.max(0, Number(line.dataset.unitPrice || 0));
      const quantity = Math.max(0, Number(input && input.value !== '' ? input.value : 0));
      const lineTotal = unitPrice * quantity;
      subtotal += lineTotal;
      const totalElement = line.querySelector('[data-cart-page-line-total]');
      if (totalElement) totalElement.textContent = money(lineTotal);
    });
    const subtotalElement = form.querySelector('[data-cart-page-subtotal]');
    if (subtotalElement) subtotalElement.textContent = money(subtotal);
    updateShippingNote(form.querySelector('[data-cart-page-shipping-note]'), subtotal);
    updateShippingProgress(form.querySelector('[data-free-shipping-progress]'), subtotal);
  }

  const cartPageUpdateTimers = new Map();
  function scheduleCartPageUpdate(input) {
    if (!input || typeof input.closest !== 'function') return;
    const line = input.closest('[data-cart-page-line]');
    const key = line?.dataset.cartKey;
    if (!key) return;
    if (cartPageUpdateTimers.has(key)) window.clearTimeout(cartPageUpdateTimers.get(key));
    const timer = window.setTimeout(async () => {
      cartPageUpdateTimers.delete(key);
      try {
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: Math.max(1, Number(input.value || 1)) })
        });
        if (!response.ok) throw new Error('Cart page update failed');
        const updatedCart = await response.json();
        setCartCount(updatedCart.item_count);
        renderCart(updatedCart);
      } catch (error) {
        document.querySelector('[data-cart-page-update]')?.classList.add('is-required');
        console.error(error);
      }
    }, 320);
    cartPageUpdateTimers.set(key, timer);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, (ch) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[ch]));
  }
  function escapeAttr(value) { return escapeHtml(value); }

  document.addEventListener('click', (event) => {
    const searchOpen = event.target.closest('[data-search-open]');
    if (searchOpen) {
      event.preventDefault();
      openSearch();
      return;
    }

    if (searchOverlay && !searchOverlay.hidden) {
      if (event.target.closest('[data-search-close]')) {
        event.preventDefault();
        closeSearch();
        return;
      }
      if (!event.target.closest('.kabo-search-overlay__panel')) {
        event.preventDefault();
        closeSearch();
        return;
      }
    }

    if (event.target.closest('[data-cart-open]')) { event.preventDefault(); openDrawer(); }
    if (event.target.closest('[data-cart-close]')) closeDrawer();
    const change = event.target.closest('[data-cart-change]');
    if (change) changeCart(change.dataset.cartChange, Number(change.dataset.quantity));

    const cartPagePlus = event.target.closest('[data-cart-page-plus]');
    const cartPageMinus = event.target.closest('[data-cart-page-minus]');
    if (cartPagePlus || cartPageMinus) {
      const control = event.target.closest('.cart-line__qty-control');
      const input = control && control.querySelector('[data-cart-page-qty]');
      if (input) {
        input.value = Math.max(1, Number(input.value || 1) + (cartPagePlus ? 1 : -1));
        updateCartPagePreview();
        scheduleCartPageUpdate(input);
      }
    }

    const plus = event.target.closest('[data-qty-plus]');
    const minus = event.target.closest('[data-qty-minus]');
    if (plus || minus) {
      const control = event.target.closest('.quantity-control');
      const input = control && control.querySelector('[data-qty-input]');
      if (input) input.value = Math.max(1, Number(input.value || 1) + (plus ? 1 : -1));
    }

    const menuToggle = event.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      closeSearch();
      const nav = document.querySelector('[data-mobile-nav]');
      if (nav) { nav.hidden = false; document.body.classList.add('menu-open'); menuToggle.setAttribute('aria-expanded','true'); }
    }
    if (event.target.closest('[data-menu-close]') || (event.target.matches('[data-mobile-nav]') && !event.target.closest('.mobile-nav__panel'))) {
      closeMobileMenu();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && searchOverlay && !searchOverlay.hidden) {
      closeSearch();
      document.querySelector('[data-search-open]')?.focus();
    }
  });

  window.addEventListener('scroll', () => {
    if (!searchOverlay || searchOverlay.hidden) return;
    const distance = Math.abs(window.scrollY - searchStartScrollY);
    if (distance > 8 && !searchScrollBlurred) {
      if (searchInput && document.activeElement === searchInput) searchInput.blur();
      searchScrollBlurred = true;
    }
    if (distance >= 240) closeSearch();
  }, { passive: true });

  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-cart-page-qty]')) {
      updateCartPagePreview();
      scheduleCartPageUpdate(event.target);
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-kabo-product-form]');
    if (!form || !window.KABO.cartDrawer) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Add to cart failed');
      await new Promise((resolve) => setTimeout(resolve, 120));
      openDrawer();
    } catch (error) {
      console.error(error);
      form.submit();
    } finally { if (button) button.disabled = false; }
  });

  function initializeProductGalleries(section) {
    const galleries = Array.from(section.querySelectorAll('.product-gallery'));
    const productName = section.querySelector('.product-title--brand, .product-title--desktop')?.textContent?.trim() || 'KABO';
    galleries.forEach((gallery) => {
      gallery.querySelectorAll('video, iframe').forEach((video, index) => {
        const label = `${productName} – Produktvideo ${index + 1}`;
        video.setAttribute('aria-label', label);
        if (video.tagName === 'IFRAME') video.setAttribute('title', label);
      });

      const visibleSlides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'))
        .filter((slide) => !slide.hidden);
      const firstSlide = visibleSlides[0];
      const videoSlides = visibleSlides.filter((slide) => slide !== firstSlide && slide.querySelector('video, iframe'));
      if (firstSlide && videoSlides.length) {
        let insertionPoint = firstSlide.nextElementSibling;
        videoSlides.forEach((slide) => {
          gallery.insertBefore(slide, insertionPoint);
          insertionPoint = slide.nextElementSibling;
        });
      }

      if (!section.hasAttribute('data-curated-product-gallery')) return;
      const orderedSlides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'))
        .filter((slide) => !slide.hidden);
      if (orderedSlides.length <= 8) return;

      orderedSlides.slice(8).forEach((slide) => {
        slide.hidden = true;
        slide.setAttribute('data-gallery-overflow', '');
      });

      const expand = document.createElement('button');
      expand.type = 'button';
      expand.className = 'button button--secondary product-gallery__expand';
      expand.textContent = 'Alle Produktbilder anzeigen';
      expand.hidden = gallery.hidden;
      expand.setAttribute('data-gallery-expand', '');
      expand.addEventListener('click', () => {
        gallery.querySelectorAll('[data-gallery-overflow]').forEach((slide) => {
          slide.hidden = false;
          slide.removeAttribute('data-gallery-overflow');
        });
        expand.remove();
      });
      gallery.insertAdjacentElement('afterend', expand);
    });
  }

  function initializeProductLightbox(section) {
    const lightbox = section.querySelector('[data-product-lightbox]');
    const allSlides = Array.from(section.querySelectorAll('[data-gallery-slide]'));
    const visibleSlides = () => allSlides.filter((slide) => !slide.hidden && !slide.closest('[hidden]'));
    let slides = visibleSlides();
    if (!lightbox || !slides.length) return;

    const stage = lightbox.querySelector('[data-lightbox-stage]');
    const count = lightbox.querySelector('[data-lightbox-count]');
    const closeButton = lightbox.querySelector('[data-lightbox-close]');
    const previousButton = lightbox.querySelector('[data-lightbox-prev]');
    const nextButton = lightbox.querySelector('[data-lightbox-next]');
    let activeIndex = 0;
    let previousFocus = null;
    let touchStartX = 0;
    let touchStartY = 0;

    const renderSlide = (index) => {
      slides = visibleSlides();
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      const source = slides[activeIndex].querySelector('video, iframe, img');
      if (!source || !stage) return;

      stage.querySelector('video')?.pause();
      stage.classList.remove('is-zoomed');
      stage.replaceChildren();

      const media = source.cloneNode(true);
      media.classList.add('product-lightbox__media');
      if (media.tagName === 'IMG') {
        media.loading = 'eager';
        media.sizes = '100vw';
        media.setAttribute('aria-label', 'Produktbild antippen, um es zu vergrößern');
      }
      if (media.tagName === 'VIDEO') {
        media.controls = true;
        media.playsInline = true;
        media.preload = 'metadata';
      }
      stage.appendChild(media);
      if (count) count.textContent = `${activeIndex + 1} / ${slides.length}`;
      if (previousButton) previousButton.hidden = slides.length < 2;
      if (nextButton) nextButton.hidden = slides.length < 2;
    };

    const openLightbox = (slide) => {
      slides = visibleSlides();
      const index = slides.indexOf(slide);
      if (index < 0) return;
      previousFocus = document.activeElement;
      slides.forEach((visibleSlide) => visibleSlide.querySelector('video')?.pause());
      lightbox.hidden = false;
      document.body.classList.add('product-lightbox-open');
      renderSlide(index);
      closeButton?.focus({ preventScroll: true });
    };

    const closeLightbox = () => {
      if (lightbox.hidden) return;
      stage?.querySelector('video')?.pause();
      stage?.replaceChildren();
      stage?.classList.remove('is-zoomed');
      lightbox.hidden = true;
      document.body.classList.remove('product-lightbox-open');
      previousFocus?.focus?.({ preventScroll: true });
    };

    allSlides.forEach((slide) => {
      slide.addEventListener('click', (event) => {
        event.preventDefault();
        openLightbox(slide);
      });
      slide.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openLightbox(slide);
      });
    });

    closeButton?.addEventListener('click', closeLightbox);
    previousButton?.addEventListener('click', () => renderSlide(activeIndex - 1));
    nextButton?.addEventListener('click', () => renderSlide(activeIndex + 1));
    stage?.addEventListener('click', (event) => {
      if (event.target === stage) {
        closeLightbox();
        return;
      }
      if (event.target.tagName === 'IMG') stage.classList.toggle('is-zoomed');
    });

    lightbox.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });
    lightbox.addEventListener('touchend', (event) => {
      if (stage?.classList.contains('is-zoomed') || !event.changedTouches.length) return;
      const deltaX = event.changedTouches[0].clientX - touchStartX;
      const deltaY = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(deltaX) < 55 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.25) return;
      renderSlide(activeIndex + (deltaX < 0 ? 1 : -1));
    }, { passive: true });

    document.addEventListener('keydown', (event) => {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        renderSlide(activeIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        renderSlide(activeIndex + 1);
      } else if (event.key === 'Tab') {
        const focusable = Array.from(lightbox.querySelectorAll('button:not([hidden]), video[controls], iframe'));
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    initializeProductGalleries(section);
    initializeProductLightbox(section);
    const json = section.querySelector('[data-product-variants]');
    if (!json) return;
    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch (_) { return; }
    const optionGroups = Array.from(section.querySelectorAll('[data-product-option-group]'));
    const optionInputs = Array.from(section.querySelectorAll('[data-product-option]'));
    const idInput = section.querySelector('[data-variant-id]');
    const prices = section.querySelectorAll('[data-product-price]');
    const compares = section.querySelectorAll('[data-product-compare]');
    const submit = section.querySelector('[data-product-submit]');
    const label = section.querySelector('[data-product-submit-label]');
    const stickyPrice = section.querySelector('[data-sticky-product-price]');
    const stickySubmit = section.querySelector('[data-sticky-add]');
    const stickyLabel = section.querySelector('[data-sticky-add-label]');
    const productGallery = section.querySelector('[data-product-gallery]');
    const grillModelPicker = section.querySelector('[data-grill-model-picker]');
    const shippingNotes = section.querySelectorAll('[data-product-shipping-note]');
    const cooltowelBundleVariantId = section.dataset.cooltowelBundleVariantId;
    const gallerySlides = productGallery ? Array.from(productGallery.querySelectorAll('[data-gallery-slide]')) : [];
    const primaryImage = gallerySlides[0]?.querySelector('img');
    const originalPrimaryImage = primaryImage?.cloneNode(false);

    const updateVariantDetails = (variant) => {
      if (!variant) return;
      shippingNotes.forEach((note) => updateShippingNote(note, variant.price));

      if (!cooltowelBundleVariantId) return;
      const isBundle = String(variant.id) === cooltowelBundleVariantId;
      section.querySelectorAll('[data-cooltowel-quantity]').forEach((quantity) => {
        quantity.textContent = isBundle ? '2 × KABO CoolTowel' : '1 × KABO CoolTowel';
      });
      section.querySelectorAll('[data-cooltowel-packaging]').forEach((packaging) => {
        packaging.textContent = isBundle ? '2er-Pack' : 'Einzelverpackung';
      });
    };

    const normalizeMediaSource = (value) => {
      if (!value) return '';
      try { return new URL(value, window.location.href).pathname; }
      catch (_) { return String(value).split('?')[0]; }
    };

    const showVariantMedia = (variant) => {
      if (!productGallery || !gallerySlides.length) return;
      const mediaId = variant.featured_media?.id;
      const imageSource = normalizeMediaSource(variant.featured_image?.src || variant.featured_media?.preview_image?.src);
      if (!mediaId && !imageSource) return;

      const selectedSlide = gallerySlides.find((slide) => {
        if (mediaId && slide.dataset.mediaId === String(mediaId)) return true;
        return Boolean(imageSource && normalizeMediaSource(slide.querySelector('img')?.src) === imageSource);
      });
      if (!selectedSlide) return;

      const sourceImage = selectedSlide === gallerySlides[0]
        ? originalPrimaryImage
        : selectedSlide.querySelector('img');
      if (!sourceImage || !primaryImage) return;

      ['src', 'srcset', 'sizes', 'alt'].forEach((attribute) => {
        const value = sourceImage.getAttribute(attribute);
        if (value === null) primaryImage.removeAttribute(attribute);
        else primaryImage.setAttribute(attribute, value);
      });
      primaryImage.loading = 'eager';
      productGallery.dataset.activeMediaId = selectedSlide.dataset.mediaId || '';

      if (productGallery.scrollWidth > productGallery.clientWidth + 1) {
        const firstVisibleSlide = gallerySlides.find((slide) => !slide.hidden);
        if (!firstVisibleSlide) return;
        const galleryOffset = productGallery.getBoundingClientRect().left;
        const slideOffset = firstVisibleSlide.getBoundingClientRect().left;
        const left = productGallery.scrollLeft + slideOffset - galleryOffset;
        if (typeof productGallery.scrollTo === 'function') {
          productGallery.scrollTo({ left, behavior: 'smooth' });
        } else {
          productGallery.scrollLeft = left;
        }
      }
    };

    const selectedOptionValues = () => optionGroups
      .map((group) => group.querySelector('[data-product-option]:checked')?.value || '');

    const updateOptionAvailability = () => {
      const selectedValues = selectedOptionValues();

      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-product-option]').forEach((input) => {
          const available = variants.some((variant) => variant.available
            && variant.options[groupIndex] === input.value
            && variant.options.slice(0, groupIndex)
              .every((value, index) => value === selectedValues[index]));
          input.disabled = !available;

          const pill = input.nextElementSibling;
          if (!pill) return;
          if (available) pill.removeAttribute('title');
          else pill.setAttribute('title', 'Diese Kombination ist aktuell nicht verfügbar');
        });
      });
    };

    const updateVariant = (event) => {
      const changedInput = event?.target?.closest('[data-product-option]');
      let values = selectedOptionValues();
      let variant = variants.find((candidate) => candidate.available
        && candidate.options.every((option, index) => option === values[index]));

      if (!variant && changedInput) {
        const changedGroup = changedInput.closest('[data-product-option-group]');
        const changedIndex = optionGroups.indexOf(changedGroup);
        const compatibleVariants = variants.filter((candidate) => candidate.available
          && candidate.options[changedIndex] === changedInput.value);

        variant = compatibleVariants
          .map((candidate) => ({
            candidate,
            matches: candidate.options.reduce((count, option, index) => (
              count + (option === values[index] ? 1 : 0)
            ), 0)
          }))
          .sort((left, right) => right.matches - left.matches)[0]?.candidate;

        if (variant) {
          optionGroups.forEach((group, index) => {
            const matchingInput = Array.from(group.querySelectorAll('[data-product-option]'))
              .find((input) => input.value === variant.options[index]);
            if (matchingInput) matchingInput.checked = true;
          });
          values = selectedOptionValues();
        }
      }

      updateOptionAvailability();

      optionGroups.forEach((group) => {
        const current = group.querySelector('[data-option-current]');
        const checked = group.querySelector('[data-product-option]:checked');
        if (current && checked) current.textContent = localizeVariantLabel(checked.value);
      });
      if (!variant) {
        if (submit) submit.disabled = true;
        if (label) label.textContent = 'Nicht verfügbar';
        if (stickySubmit) stickySubmit.disabled = true;
        if (stickyLabel) stickyLabel.textContent = 'Nicht verfügbar';
        return;
      }
      if (idInput) idInput.value = variant.id;
      prices.forEach((price) => { price.textContent = money(variant.price); });
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      updateVariantDetails(variant);
      compares.forEach((compare) => {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) { compare.textContent = money(variant.compare_at_price); compare.hidden = false; }
        else { compare.hidden = true; }
      });
      if (submit) submit.disabled = !variant.available;
      if (label) label.textContent = variant.available ? 'In den Warenkorb' : 'Nicht verfügbar';
      if (stickySubmit) stickySubmit.disabled = !variant.available;
      if (stickyLabel) stickyLabel.textContent = variant.available ? 'In den Warenkorb' : 'Nicht verfügbar';
      showVariantMedia(variant);
      if (history.replaceState) {
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      }
    };
    const initialVariant = variants.find((variant) => String(variant.id) === idInput?.value);
    if (initialVariant) {
      prices.forEach((price) => { price.textContent = money(initialVariant.price); });
      if (stickyPrice) stickyPrice.textContent = money(initialVariant.price);
      updateVariantDetails(initialVariant);
      if (!grillModelPicker) showVariantMedia(initialVariant);

      if (section.hasAttribute('data-eu-only-variants') && history.replaceState) {
        const url = new URL(window.location.href);
        const requestedVariant = url.searchParams.get('variant');
        if (requestedVariant && requestedVariant !== String(initialVariant.id)) {
          url.searchParams.set('variant', initialVariant.id);
          history.replaceState({}, '', url);
        }
      }
    }
    updateOptionAvailability();

    const grillModelData = section.querySelector('[data-grill-model-data]');
    if (grillModelPicker && grillModelData) {
      let models = {};
      try { models = JSON.parse(grillModelData.textContent); } catch (_) { models = {}; }
      const modelInputs = Array.from(grillModelPicker.querySelectorAll('[data-grill-model-input]'));
      const modelGalleries = Array.from(section.querySelectorAll('[data-grill-model-gallery]'));
      const modelLabel = grillModelPicker.querySelector('[data-grill-model-current]');
      const productIdInput = section.querySelector('[data-kabo-product-form] input[name="product-id"]');

      const applyGrillModel = (input, updateUrl = true) => {
        const selectedModel = models[input?.value];
        if (!selectedModel?.variant || input.disabled) return;
        const pickerTopBeforeChange = grillModelPicker.getBoundingClientRect().top;
        const variant = selectedModel.variant;
        modelInputs.forEach((candidate) => { candidate.checked = candidate === input; });
        if (modelLabel) modelLabel.textContent = input.value === 'standard' ? 'Standard' : 'Pro';
        if (idInput) idInput.value = variant.id;
        if (productIdInput) productIdInput.value = selectedModel.productId;
        if (selectedModel.deliveryTime) {
          section.querySelectorAll('[data-product-delivery-time]').forEach((deliveryTime) => {
            deliveryTime.textContent = selectedModel.deliveryTime;
          });
        }
        prices.forEach((price) => { price.textContent = money(variant.price); });
        if (stickyPrice) stickyPrice.textContent = money(variant.price);
        updateVariantDetails(variant);
        compares.forEach((compare) => {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compare.textContent = money(variant.compare_at_price);
            compare.hidden = false;
          } else {
            compare.hidden = true;
          }
        });
        if (submit) submit.disabled = !variant.available;
        if (label) label.textContent = variant.available ? 'In den Warenkorb' : 'Nicht verfügbar';
        if (stickySubmit) stickySubmit.disabled = !variant.available;
        if (stickyLabel) stickyLabel.textContent = variant.available ? 'In den Warenkorb' : 'Nicht verfügbar';

        section.querySelectorAll('[data-grill-model-description]').forEach((description) => {
          description.hidden = description.dataset.grillModelDescription !== input.value;
        });

        modelGalleries.forEach((gallery) => {
          gallery.hidden = gallery.dataset.grillModelGallery !== input.value;
          const galleryExpand = gallery.nextElementSibling;
          if (galleryExpand?.hasAttribute('data-gallery-expand')) galleryExpand.hidden = gallery.hidden;
          if (!gallery.hidden) gallery.scrollLeft = 0;
          else gallery.querySelectorAll('video').forEach((video) => video.pause());
        });

        if (updateUrl) {
          requestAnimationFrame(() => {
            const pickerOffset = grillModelPicker.getBoundingClientRect().top - pickerTopBeforeChange;
            if (Math.abs(pickerOffset) > 1) {
              window.scrollTo({
                left: window.scrollX,
                top: window.scrollY + pickerOffset,
                behavior: 'instant'
              });
            }
          });
        }

        if (updateUrl && history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('model', input.value);
          if (input.value === 'pro') url.searchParams.set('variant', variant.id);
          else url.searchParams.delete('variant');
          history.replaceState({}, '', url);
        }
      };

      modelInputs.forEach((input) => input.addEventListener('change', () => applyGrillModel(input)));
      const modelParameters = new URL(window.location.href).searchParams;
      const requestedModel = modelParameters.get('model');
      const initialModelInput = modelInputs.find((input) => input.value === requestedModel && !input.disabled)
        || (!modelParameters.has('variant') && modelInputs.find((input) => input.value === 'standard' && !input.disabled))
        || modelInputs.find((input) => input.checked && !input.disabled)
        || modelInputs.find((input) => !input.disabled);
      if (initialModelInput) applyGrillModel(initialModelInput, false);
    }

    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
    if (stickySubmit) {
      stickySubmit.addEventListener('click', () => {
        if (!stickySubmit.disabled && submit) submit.click();
      });
    }
  });

  refreshCart();
})();
